var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStatusNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409.000000, -389.000000) translate(377.192308, 182.000000) translate(7.807692, 111.000000) translate(17.000000, 44.000000) translate(3.000000, 48.000000) translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F84C1E"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 6.794L6.182 5.037l-.063-.054c-.326-.246-.77-.212-1.045.073L5 5.145c-.223.31-.19.745.093 1.018l1.779 1.721-1.817 1.758-.056.06c-.256.318-.237.763.038 1.047l.086.078c.303.232.739.214 1.021-.059L8 8.973l1.856 1.795.062.054c.326.246.77.212 1.045-.073l.075-.089c.222-.31.19-.745-.094-1.018L9.126 7.884l1.781-1.72.056-.061c.257-.318.238-.763-.037-1.047-.3-.312-.797-.32-1.108-.02L8 6.795z"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusNegative);
export default __webpack_public_path__ + "static/media/icon-status-negative.8fe764e5a0d5e2eee6f0581d5f13a177.svg";
export { ForwardRef as ReactComponent };